import { css, keyframes } from "styled-components";

const bounce = keyframes`
    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
    40% {transform: translateY(-20px);}
    60% {transform: translateY(-10px);}
`;

const fade = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

const pulse = keyframes`
  0% { opacity: 1.0 }
  50% { opacity: 0.3 }
  100% { opacity: 1.0 }
`;

const Animations = {
    bounce: css`
        ${bounce} 2s linear infinite
    `,
    fadeIn: css`
        ${fade} 0.5s ease forwards
    `,
    glow: css`
        ${pulse} 3s infinite ease-in-out
    `,
};

export default Animations;
